import { render, staticRenderFns } from "./assist_server.vue?vue&type=template&id=482fad0f&scoped=true"
import script from "./assist_server.vue?vue&type=script&lang=js"
export * from "./assist_server.vue?vue&type=script&lang=js"
import style0 from "./assist_server.vue?vue&type=style&index=0&id=482fad0f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482fad0f",
  null
  
)

export default component.exports